import { generateUrl } from "@services/generateUrl/generateUrl"
import { onRequestSuccess, onResponseRejected } from "@services/interceptors"
import axios from "axios"

const STRIPE_URL = generateUrl()

const stripeAccountServiceApiInstance = axios.create({
    baseURL: `${STRIPE_URL}/fc-payment/stripe`
})

stripeAccountServiceApiInstance.interceptors.request.use(onRequestSuccess, undefined)
stripeAccountServiceApiInstance.interceptors.response.use(undefined, onResponseRejected)

export default stripeAccountServiceApiInstance
